export default __webpack_public_path__ + "static/media/slide-2.9d6b8503.jpg";